import { Component, OnInit } from '@angular/core';
import { CarrierService } from 'app/services/carrier.service';
import { AuthWebService } from 'app/services/authweb.service';
import { Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { CarrierAccountService } from 'app/services/carrier-account.service';
import { PopupService } from 'app/services/shared/popup.service';
import { DialogService } from 'ng2-bootstrap-modal';
import { EnterConfirmationPopupComponent } from './enter-confirmation-popup/enter-confirmation-popup.component';
import { ToastNotificationService } from 'app/shared/toast-notification/toast-notification.service';

@Component({
  selector: 'app-delink-carrier-account',
  templateUrl: './delink-carrier-account.component.html',
  styleUrls: ['./delink-carrier-account.component.css']
})
export class DeLinkCarrierAccountComponent implements OnInit {

  isLoading: Boolean = false;
  message: string = 'Loading  carrier accounts, please wait...';
  carrierAccounts: any = [];
    userData: any;
    carrierCode: string;
  
  user: any = {};
  constructor(private carrierAccountService: CarrierAccountService, private carrierService: CarrierService, private authWebService: AuthWebService, private router: Router,
    private toaster: ToastrService,private toastService:ToastNotificationService,
    private showModal: PopupService, public dialogService: DialogService) { 
      this.user = (this.authWebService.userData) ? this.authWebService.userData.User : null;
    }

  ngOnInit() {
    this.userData = this.authWebService.userData;
    }

    GetAccounts() {
        this.carrierAccountService.GetLinkedCarrierAccounts(this.userData.User.ID).subscribe(result => {
            this.carrierAccounts = result;
        });
    }

    onSearch() {
        this.carrierAccountService.GetLinkedCarrierAccountsByCarrierCode(this.carrierCode).subscribe(result => {
            this.carrierAccounts = result;
            if (this.carrierAccounts == null || this.carrierAccounts.length < 1) {
                this.toastService.error('No carrier account found using "' + this.carrierCode + '".','Error');
            }
        });
    }

  enterConfirmation(legacy_carrier_code) {
      this.dialogService.addDialog(EnterConfirmationPopupComponent, {
      title: 'Confirm Carrier Account De-Linking',
          message: 'Are you sure you want to delink ' + legacy_carrier_code + "?",
      comment: ``,
      confirmButtonText: 'Confirm',
      cancelButtonText: 'Cancel',
          account: legacy_carrier_code
    }).subscribe((isConfirmed) => {
        if (isConfirmed) {
            this.carrierCode = legacy_carrier_code;
            this.onSearch();
          this.toastService.success('' + legacy_carrier_code + ' has been successfully de-linked.','Success');
      } else {
        this.toastService.error('An error occured, please try again.','Error');
      }
    });
  }
}
